import { Pipe, PipeTransform } from '@angular/core';
import { formatRange } from '../utils/format-range';

@Pipe({
  name: 'dateRange',
})
export class DateRangePipe implements PipeTransform {
  transform(startDate: Date | number | bigint, endDate: Date | number | bigint) {
    return formatRange(startDate, endDate);
  }
}
